import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import type { VideoItem } from '@/mocks/videos';

interface RelatedVideosProps {
  currentId: string;
  relatedIds: string[];
}

export default function RelatedVideos({ currentId, relatedIds }: RelatedVideosProps) {
  const related = relatedIds
    .map((id) => videos.find((v) => v.id === id))
    .filter((v): v is VideoItem => v !== undefined && v.id !== currentId);

  if (related.length === 0) return null;

  return (
    <div>
      <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
        相关推荐
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-product-shop="">
        {related.map((video) => (
          <Link
            key={video.id}
            to={`/video/${video.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-2">
              <img
                src={video.coverImage}
                alt={video.title}
                title={`${video.title} - 51影视免费在线观看`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute top-2 left-2">
                <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                  {video.rating}
                </span>
              </div>
            </div>
            <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
              {video.title}
            </h4>
            <p className="text-xs text-foreground-500 mt-1">{video.category} · {video.year}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}